import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

export const getInstructionalLevels = async () => {
    const { data } = await axios.get(API_ROUTES.INSTRUCTIONAL_LEVELS);
    return data;
};